module.exports = __webpack_public_path__ + "img/closeicon.7a683d4a.svg";